<template>
  <div class="header">
    <h1>用戶管理 - 新增企業用戶</h1>
  </div>
  <div>
    <div class="user-img" @click="showPhoto = true">
      <CImage v-if="image" width="150" rounded height="150" :src="image" />
      <CImage v-else :src="require(`@/assets/icons/user.svg`)" />
    </div>
    <CropPicture
      :show="showPhoto"
      @close="showPhoto = false"
      @image="image = $event"
    />
  </div>
  <div
    class="text-center d-flex align-items-center justify-content-center mb-5"
  >
    <span class="text-danger me-1">*</span>
    <input
      type="text"
      v-model="name"
      class="rounded border px-2"
      placeholder="請入企業名稱"
    />
  </div>
  <span class="text-danger">*為必填</span>
  <div
    v-for="item in userInfo"
    :key="item"
    class="col-12 d-flex align-items-center justify-content-between pt-4 col-12"
  >
    <span class="text-nowrap col-1 text-center">
      <span
        v-if="
          item.name !== 'company_address' &&
          item.name !== 'company_phone' &&
          item.name !== 'official_website'
        "
        class="text-danger"
        >*
      </span>
      {{ item.label }}</span
    >
    <div class="col-11 d-flex align-items-center position-relative">
      <input
        v-if="(item.name !== 'company_phone' && item.name !== 'mobile')"
        class="rounded-pill border info"
        v-model="item.value"
        :type="item.type"
        :placeholder="item.placeholder"
      />
      <input
        v-else
        class="rounded-pill border info"
        v-model="item.value"
        :placeholder="item.placeholder"
        @change="ChangeNumber"
        oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
      />
      <img
        v-if="item.name === 'password' || item.name === 'password2'"
        class="show-password"
        :src="
          item.type === 'text'
            ? require('@/assets/icons/open-eye.svg')
            : require('@/assets/icons/close-eye.svg')
        "
        :alt="item.type === 'text' ? 'open-eye' : 'close-eye'"
        @click="item.type = item.type === 'password' ? 'text' : 'password'"
      />
    </div>
  </div>

  <div
    class="position-relative d-flex align-items-center justify-content-between pt-4 pb-5 col-12"
  >
    <span class="text-nowrap col-1 text-center">
      <span class="text-danger">*</span>
      用戶狀態</span
    >
    <select v-model="state" class="rounded-pill state col-11 border">
      <option
        v-for="option in options"
        :value="option.value"
        :key="option.value"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
  <div class="col-12 d-flex align-items-center justify-content-center">
    <button
      :disabled="!isPassed"
      @click="submit"
      class="btn btn-outline-primary user-btn rounded-pill col-3 ms-2"
    >
      完成
    </button>
  </div>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import { ref } from '@vue/reactivity'
import useInfo from '@/composables/useInfo'
import MsgBox from '@/components/MsgBox.vue'
import useQuestionnaire from '@/composables/useQuestionnaire'
import { computed, watch } from '@vue/runtime-core'
import { useRoute } from 'vue-router'
import CropPicture from '@/components/CropPicture.vue'
import router from '@/router'
import verifyForm from '@/utils/verifyForm'

export default {
  components: {
    MsgBox,
    CropPicture,
  },
  setup() {
    const { signUp } = useInfo()
    const { getFormList } = useQuestionnaire()
    const route = useRoute()
    const options = ref([
      { text: '啟用', value: '1' },
      { text: '凍結', value: '2' },
    ])
    const showMsgBox = ref(false)
    const showPassword = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const name = ref('')
    const state = ref('1')
    const formList = ref([])
    const showPhoto = ref(false)
    const image = ref('')
    const getList = async () => {
      const res = await getFormList()
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        formList.value = res.ret['form-list']
      }
    }
    getList()
    const getInfo = computed(() => {
      return formList.value.find((e) => {
        return e.id === +route.params.id
      })
    })
    const userInfo = ref([
      {
        name: 'company_address',
        label: '企業地址',
        type: 'text',
        placeholder: '請輸入企業地址 例：臺北市大安區忠孝東路4段218之1號10樓',
        value: undefined,
      },
      {
        name: 'company_phone',
        label: '企業電話',
        placeholder: '請輸入企業電話 例：0287715543',
        type: 'number',
        value: undefined,
      },
      {
        name: 'uniform_numbers',
        label: '統一編號',
        placeholder: '請輸入統一編號 例：24939462',
        type: 'text',
        value: undefined,
      },
      {
        name: 'official_website',
        label: '官方網站',
        placeholder: '請輸入官方網站 例：https://www.google.com',
        type: 'text',
        value: undefined,
      },
      {
        name: 'email',
        label: '郵件地址',
        placeholder: '請輸入郵件地址 例：service@gmail.com',
        type: 'text',
        value: undefined,
      },
      {
        name: 'contact_person',
        label: '聯絡人',
        placeholder: '請輸入聯絡人 例：王小明',
        type: 'text',
        value: undefined,
      },
      {
        name: 'mobile',
        label: '聯絡電話',
        placeholder: '請輸入聯絡電話 例：0912345678',
        type: 'number',
        value: undefined,
      },
      {
        name: 'username',
        label: '登入帳號',
        placeholder: '請輸入至少五位數登入帳號 ',
        type: 'text',
        value: undefined,
      },
      {
        name: 'password',
        label: '登入密碼',
        placeholder: '請輸入至少六位數登入密碼 ',
        type: 'password',
        value: undefined,
      },
      {
        name: 'password2',
        label: '確認密碼',
        placeholder: '請輸入至少六位數確認密碼 ',
        type: 'password',
        value: undefined,
      },
    ])
    watch(getInfo, () => {
      name.value = getInfo.value?.company_name
      userInfo.value = [
        {
          name: 'company_address',
          label: '企業地址',
          value: getInfo.value?.company_address,
          placeholder: '請輸入企業地址 例：臺北市大安區忠孝東路4段218之1號10樓',
        },
        {
          name: 'company_phone',
          label: '企業電話',
          value: getInfo.value?.company_phone,
          placeholder: '請輸入企業電話 例：02-87715543',
        },
        {
          name: 'uniform_numbers',
          label: '統一編號',
          value: getInfo.value?.uniform_numbers,
          placeholder: '請輸入統一編號 例：24939462',
        },
        {
          name: 'official_website',
          label: '官方網站',
          value: getInfo.value?.official_website,
          placeholder: '請輸入官方網站 例：https://www.google.com',
        },
        {
          name: 'email',
          label: '電子郵件',
          value: getInfo.value?.email,
          placeholder: '請輸入郵件地址 例：service@gmail.com',
        },
        {
          name: 'contact_person',
          label: '聯絡人',
          value: getInfo.value?.name,
          placeholder: '請輸入聯絡人 例：王小明',
        },
        {
          name: 'mobile',
          label: '聯絡電話',
          value: getInfo.value?.phone,
          placeholder: '請輸入聯絡電話 例：0912345678',
        },
        {
          name: 'username',
          label: '登入帳號',
          value: '',
          placeholder: '請輸入至少五位數登入帳號 ',
        },
        {
          name: 'password',
          label: '登入密碼',
          value: '',
          placeholder: '請輸入至少六位數登入密碼 ',
          type: 'password',
        },
        {
          name: 'password2',
          label: '確認密碼',
          value: '',
          placeholder: '請輸入至少六位數確認密碼 ',
          type: 'password',
        },
      ]
    })

    const isPassed = computed(() => {
      const requiredField = [
        'uniform_numbers',
        'email',
        'username',
        'password',
        'password2',
        'company_name',
        'contact_person',
        'mobile',
        'state',
      ]
      return requiredField.every((key) => {
        return formData.value[key]
      })
    })

    const formData = computed(() => {
      const info = userInfo.value.reduce(function (target, key) {
        if(key.value){
          target[key.name] = String(key.value)
        }
        return target
      }, {})
      info.company_name = name.value
      info.state = state.value
      info.user_information_form_id = route.params.id
      info.avatar_image = image.value
      return info
    })

    const submit = async () => {
      const rules = {
        company_phone: '^(0[0-9]{1}-)?([0-9]{6,8})+(#[0-9]{1,4})?$',
        uniform_numbers: '^[0-9]{8}$',
      }
      const errorMessages = {
        company_phone: '企業電話格式錯誤',
        uniform_numbers: '統一編號格式錯誤',
      }
      const passed = verifyForm(formData.value, rules, errorMessages)
      if (passed.error) {
        showMsgBox.value = true
        errorMsg.value = passed.errorMessage
        return
      }

      const res = await signUp(formData.value)
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        showMsgBox.value = true
        errorMsg.value = '新增成功'
        setTimeout(()=>{
          router.push('/user-management/user-enterprise-list')
        }, 1000)
      }
    }
    const ChangeNumber = ($event) => {
      if ($event?.targ$eventt?.value) {
        $event.target.value = `${Number($event.target.value)}`
      }
    };
    return {
      userInfo,
      errorCode,
      options,
      submit,
      showMsgBox,
      errorMsg,
      name,
      state,
      getInfo,
      getList,
      formList,
      showPhoto,
      image,
      showPassword,
      isPassed,
      ChangeNumber
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 40px 0px;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
}
.user-img {
  width: 160px;
  height: 160px;
  border: 1px #eff0f6 solid;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 64px auto 16px;
}
.info {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #4d4d4d;
}
.state {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #4d4d4d;
}
input::placeholder {
  font-size: 16px;
}
select {
  background: url('~@/assets/icons/arrow-down.svg') no-repeat scroll 97% center
    transparent;
  appearance: none;
  color: #4d4d4d;
}

.copy {
  right: 32px;
}

.user-btn {
  height: 48px;
  margin: 24px 0 72px 0;
}
.show-password {
  right: 32px;
  position: absolute;
  cursor: pointer;
}
</style>
